/* /usr/share/hubspot/build/.hubspot/static-archive/HublyticsTrackerJS/static-3.8/coffee/utils.coffee */
(function () {
window.hublytics = {
  eventClasses: {
    USAGE: "USAGE",
    WARNING: "WARNING",
    ERROR: "ERROR",
    INTERACTION: "INTERACTION",
    VIEW: "VIEW",
    ACTIVATION: "ACTIVATION",
    SIGNUP: "SIGNUP",
    EXPOSURE: "EXPOSURE",
    CREATION: "CREATION",
    NONE: "NONE"
  },
  selectorify: function(node) {
    var _getSelector, sels;
    _getSelector = function(node, sels) {
      var id, parent, sel;
      sel = "";
      id = node.id;
      if (id) {
        sel += "#" + node.id;
        sels.unshift(sel);
        return sels;
      }
      sel += node.tagName.toLowerCase();
      if (node.classList.length) {
        sel += "." + Array.prototype.join.call(node.classList, ".");
      }
      sels.unshift(sel);
      parent = node.parentElement;
      if (!parent || parent.nodeType !== 1) {
        return sels;
      }
      return _getSelector(parent, sels);
    };
    if (!node && node.nodeType !== 1) {
      throw new TypeError("Node is not an element");
    }
    sels = _getSelector(node, []);
    return sels.join(" > ");
  },
  isObject: function(obj) {
    var type;
    type = typeof obj;
    return type === "function" || type === "object" && !!obj;
  },
  extend: function(obj) {
    var i, length, prop, source;
    if (!hublytics.isObject(obj)) {
      return obj;
    }
    source = void 0;
    prop = void 0;
    i = 1;
    length = arguments.length;
    while (i < length) {
      source = arguments[i];
      for (prop in source) {
        if (hasOwnProperty.call(source, prop)) {
          obj[prop] = source[prop];
        }
      }
      i++;
    }
    return obj;
  },
  trim: function(string) {
    if (typeof String.prototype.trim !== 'function') {
      return string.replace(/^\s+|\s+$/g, '');
    } else {
      return string.trim();
    }
  },
  getCookie: function(name) {
    var cookie, cookieValue, cookies, j, len;
    cookieValue = null;
    if (document.cookie && document.cookie !== '') {
      cookies = document.cookie.split(';');
      for (j = 0, len = cookies.length; j < len; j++) {
        cookie = cookies[j];
        cookie = hublytics.trim(cookie);
        if (cookie.substring(0, name.length + 1) === (name + "=")) {
          cookieValue = cookie.substring(name.length + 1);
          return cookieValue;
        }
      }
    }
  },
  setCookie: function(name, value, expiresInMillis) {
    var d, expiryDate;
    if (expiresInMillis == null) {
      expiresInMillis = 60 * 24 * 60 * 60 * 1000;
    }
    d = new Date();
    d.setTime(d.getTime() + expiresInMillis);
    expiryDate = d.toGMTString();
    return document.cookie = name + '=' + value + ';expires=' + expiryDate + ';path=/';
  },
  deleteCookie: function(name) {
    return document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/';
  },
  getStorage: function(key) {
    var error, stored;
    try {
      stored = window.localStorage.getItem(key);
      if (stored) {
        return JSON.parse(stored);
      }
    } catch (error) {
      stored = hublytics.getCookie(key);
      if (stored) {
        return JSON.parse(decodeURIComponent(stored));
      }
    }
  },
  setStorage: function(key, value) {
    var error, stored;
    try {
      return window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
      return stored = hublytics.setCookie(key, encodeURIComponent(JSON.stringify(value)));
    }
  },
  clearStorage: function(key) {
    var error;
    try {
      return window.localStorage.removeItem(key);
    } catch (error) {
      return hublytics.deleteCookie(key);
    }
  },
  LOG_PREFIX: "[HublyticsTrackerJS]",
  log: function() {
    var args;
    try {
      if (window.localStorage.HUBLYTICS_DEBUG === "true") {
        args = Array.prototype.slice.apply(arguments);
        args.unshift(this.LOG_PREFIX);
        return console.log.apply(console, args);
      }
    } catch (undefined) {}
  },
  warn: function() {
    var args;
    try {
      if (window.localStorage.HUBLYTICS_DEBUG === "true") {
        args = Array.prototype.slice.apply(arguments);
        args.unshift(this.LOG_PREFIX);
        return console.warn.apply(console, args);
      }
    } catch (undefined) {}
  },
  error: function() {
    var args;
    args = Array.prototype.slice.apply(arguments);
    args.unshift(this.LOG_PREFIX);
    return console.error.apply(console, args);
  },
  getBaseDomain: function() {
    var spliced, splits;
    splits = window.location.host.split('.');
    spliced = splits.slice(splits.length - 2);
    return spliced.join('.');
  },
  makeUuid: function() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
      var r, v;
      r = Math.random() * 16 | 0;
      if (c === 'x') {
        v = r;
      } else {
        v = r & 0x3 | 0x8;
      }
      return v.toString(16);
    });
  },
  getValidLocaleString: function() {
    var ref;
    if (typeof I18n !== "undefined" && I18n !== null ? (ref = I18n.fired) != null ? ref['ready'] : void 0 : void 0) {
      return I18n.locale;
    } else if (navigator) {
      return navigator.language || navigator.userLanguage || void 0;
    }
  }
};

if (typeof hubspot !== 'undefined' && hubspot.define) {
  hubspot.define('hubspot.HublyticsTrackerJS.utils', [], function() {
    return window.hublytics;
  });
}
}());




//////////////////
// WEBPACK FOOTER
// ../~/bender-webpack/lib/legacy-modules/module-manifest-dependency-loader.js!../~/bender-webpack/lib/no-parse-loader.js!../~/bender-webpack/lib/sporks/loader.js!/usr/share/hubspot/build/.hubspot/static-archive/HublyticsTrackerJS/static-3.8/coffee/utils.coffee
// module id = 593
// module chunks = 